<footer class="footer   no-print">
      <div class="mainfoot-div p-2">
            <div class="container-fluid">
                  <div class="row">
                        <div class="col-sm-7 col-md-8">
                            <p style="float: left;">copyright © {{ currentYear }}. All rights reserved to USLegalization.</p>
                        </div>
                        <div class="col-sm-5 col-md-4" style="padding-right: 40px;">
                              <ul class="social_footer_ul">
                                  <li><a href="https://www.linkedin.com/company/uslegalization/" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                                  <li><a href="https://www.facebook.com/uslegalization/" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                  <!-- <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                  <li><a href="#"><i class="fas fa-rss color-fa"></i></a></li> -->
                              </ul>
                        </div>
                  </div>
            </div>
      </div>
</footer>